import { useTranslation } from '../../../../../../../../../../../../hooks';
import { UserPaymentDetailsFormContentBankAccountDetailsBankDataProps } from './props';
import styles from './styles.module.scss';
import { FormGroup, Input } from '@starsoft/common/components';

/**
 * UserPaymentDetailsFormContentBankAccountDetailsBankData Component
 * This component is responsible for rendering the bank details such as bank name and bank code.
 *
 * @param {UserPaymentDetailsFormContentBankAccountDetailsBankDataProps} props - The properties for the component.
 * @param {Bank} props.bank - The bank object containing the bank details.
 *
 * @returns {JSX.Element} The rendered component displaying the bank details.
 *
 * @example
 * // Usage example:
 * <UserPaymentDetailsFormContentBankAccountDetailsBankData bank={{ name: 'Bank of Nigeria', code: '123' }} />
 */
export default function UserPaymentDetailsFormContentBankAccountDetailsBankData({
  bank,
}: UserPaymentDetailsFormContentBankAccountDetailsBankDataProps) {
  // Translation hook for internationalization
  const { t } = useTranslation('common');

  return (
    <div className={styles.row}>
      {/* Form group for displaying the bank name */}
      <FormGroup label={t('bank_name_label')}>
        <Input readOnly value={bank?.name} />
      </FormGroup>
      {/* Form group for displaying the bank code */}
      <FormGroup label={t('bank_code_label')}>
        <Input readOnly value={bank?.code} />
      </FormGroup>
    </div>
  );
}
